// extracted by mini-css-extract-plugin
module.exports = {"link":"CategoryLink_link__wYVUn"};